"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneNumberInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const countryCodeUtils_1 = require("./countryCodeUtils");
const PhoneNumberInput_module_css_1 = __importDefault(require("./PhoneNumberInput.module.css"));
const country_code_emoji_1 = require("country-code-emoji");
function CountryOption({ countryCode }) {
    const phoneNumberCodeForRegion = (0, countryCodeUtils_1.getPhoneNumberCodeForRegion)(countryCode);
    const displayValue = (0, country_code_emoji_1.countryCodeEmoji)(countryCode) + ` ${countryCode} ${phoneNumberCodeForRegion}`;
    return (0, jsx_runtime_1.jsx)("option", { value: countryCode, children: displayValue });
}
/**
 * Phone number input field.
 * On change, returns (country code + phone number)
 */
function PhoneNumberInput({ onChange }) {
    const [phoneNumber, setPhoneNumber] = (0, react_1.useState)({
        regionCode: countryCodeUtils_1.defaultRegion,
        number: "",
    });
    return ((0, jsx_runtime_1.jsxs)("div", { className: PhoneNumberInput_module_css_1.default.container, children: [(0, jsx_runtime_1.jsxs)("select", { value: phoneNumber.regionCode, onChange: (e) => {
                    setPhoneNumber((prev) => {
                        const regionCode = e.target.value;
                        onChange((0, countryCodeUtils_1.getPhoneNumberCodeForRegion)(regionCode) + prev.number);
                        return { regionCode, number: prev.number };
                    });
                }, children: [countryCodeUtils_1.PRIMARY_REGION_CODES.map((code, i) => ((0, jsx_runtime_1.jsx)(CountryOption, { countryCode: code }, `${code}-${i}`))), (0, jsx_runtime_1.jsx)("option", { value: "separator", disabled: true, children: "---------" }, "separator"), countryCodeUtils_1.ALL_REGIONS.map((code, i) => ((0, jsx_runtime_1.jsx)(CountryOption, { countryCode: code }, `${code}-${i}`)))] }), (0, jsx_runtime_1.jsx)("input", { type: "tel", name: "telphone", maxLength: 12, autoComplete: "tel-national", onChange: (e) => {
                    setPhoneNumber((prev) => {
                        const number = e.target.value;
                        onChange((0, countryCodeUtils_1.getPhoneNumberCodeForRegion)(prev.regionCode) + number);
                        return { regionCode: prev.regionCode, number };
                    });
                } })] }));
}
exports.PhoneNumberInput = PhoneNumberInput;
//# sourceMappingURL=index.js.map